<template>
    <img :src="url" />
</template>

<script>
import { baseUrl } from "../constants";
export default {
    props: ["src"],
    computed: {
        url() {
            return this.src.startsWith("http") ? this.src : baseUrl + "/" + this.src;
        }
    }
};
</script>